import React, { useState, useEffect, useContext } from 'react';
import { Grid, FormLabel, FormHelperText } from '@material-ui/core';
import { TextBox, SelectBox, DatePicker, SecondaryButton } from '../../../../Core/FormInput';
import { postWorkshopShiftSchedulesAddUpdate } from '../../../../Core/Service/WorkshopShiftSchedule-service';
import AppContext from '../../../../App/AppContext';
import moment from 'moment';

const CreateCalendarModal = (props) => {
    const { onClose, shiftList, branchID, branchName, defaultStartDate, defaultEndDate, existingSchedule } = props;
    const { showToast } = useContext(AppContext);

    console.log(props, 'props');

    const [state, setState] = useState({
        shiftID: '',
        startDate: '',
        endDate: '',
        maxTechniciansRequired: 2,
        shiftScheduleID: null
    });
    const [errors, setErrors] = useState({});
    const [isBtnLoader, setIsBtnLoader] = useState(false);

    useEffect(() => {
        if (existingSchedule) {
            setState({
                shiftID: existingSchedule.shiftID || '',
                startDate: existingSchedule.shiftDate ? moment(existingSchedule.shiftDate).format('YYYY-MM-DD') : '',
                endDate: existingSchedule.shiftDate ? moment(existingSchedule.shiftDate).format('YYYY-MM-DD') : '',
                maxTechniciansRequired: existingSchedule.maxTechniciansRequired ?? 2,
                shiftScheduleID: existingSchedule.shiftScheduleID || null
            });
        } else {
            setState({
                shiftID: shiftList?.[0]?.id || '',
                startDate: defaultStartDate ? moment(defaultStartDate).format('YYYY-MM-DD') : '',
                endDate: defaultEndDate ? moment(defaultEndDate).format('YYYY-MM-DD') : '',
                maxTechniciansRequired: 2,
                shiftScheduleID: null
            });
        }
    }, [existingSchedule, shiftList, defaultStartDate, defaultEndDate]);

    const handleInput = (e) => {
        const { name, value } = e.target;
        setState((prev) => ({
            ...prev,
            [name]: name === 'maxTechniciansRequired' ? (value === '' ? '' : parseInt(value, 10)) : value
        }));
        if (errors[name]) {
            setErrors((err) => ({ ...err, [name]: null }));
        }
    };

    const validate = () => {
        const tempErrors = {};
        if (!state.shiftID) tempErrors.shiftID = 'Shift is required';
        if (!state.startDate) tempErrors.startDate = 'Start Date is required';
        if (!state.endDate) tempErrors.endDate = 'End Date is required';
        if (state.startDate && state.endDate && state.startDate > state.endDate) {
            tempErrors.endDate = 'End Date must be after Start Date';
        }
        if (state.maxTechniciansRequired === '' || state.maxTechniciansRequired < 0) {
            tempErrors.maxTechniciansRequired = 'Max Technicians must be 0 or more';
        }
        setErrors(tempErrors);
        return Object.keys(tempErrors).length === 0;
    };

    const handleSubmit = async () => {
        if (!validate()) return;

        setIsBtnLoader(true);
        try {
            const payload = {
                ShiftID: state.shiftID,
                BranchID: parseInt(branchID, 10),
                StartDate: moment.utc(state.startDate).startOf('day').toISOString(),
                EndDate: moment.utc(state.endDate).startOf('day').toISOString(),
                MaxTechniciansRequired: state.maxTechniciansRequired,
                ShiftScheduleID: state.shiftScheduleID
            };

            const res = await postWorkshopShiftSchedulesAddUpdate(payload);
            if (res.success || res.data?.success) {
                showToast(res.data?.message || res.message || (existingSchedule ? 'Schedule updated successfully' : 'Schedule created successfully'), 'success');
                onClose(true);
            } else {
                showToast(res.data?.message || res.message || 'Failed to save shift schedule', 'error');
            }
        } catch (error) {
            console.error('Error saving shift schedule:', error);
            showToast('An error occurred while saving the shift schedule', 'error');
        } finally {
            setIsBtnLoader(false);
        }
    };

    return (
        <Grid container spacing={2} style={{ padding: '8px' }}>
            {/* ── Context Info ── */}
            {(branchName || state.shiftID) && (
                <Grid item xs={12}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', paddingBottom: 8, borderBottom: '1px solid #E5E7EB', marginBottom: 4 }}>
                        {branchName && (
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <span style={{ fontSize: 11, color: '#6B7280', textTransform: 'uppercase', fontWeight: 600, letterSpacing: '0.05em' }}>Branch</span>
                                <strong style={{ fontSize: 15, color: '#111827', marginTop: 2 }}>{branchName}</strong>
                            </div>
                        )}
                        {state.shiftID && (
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                                <span style={{ fontSize: 11, color: '#6B7280', textTransform: 'uppercase', fontWeight: 600, letterSpacing: '0.05em' }}>Shift</span>
                                <strong style={{ fontSize: 15, color: '#111827', marginTop: 2 }}>
                                    {shiftList?.find((s) => String(s.id) === String(state.shiftID))?.name || ''}
                                </strong>
                            </div>
                        )}
                    </div>
                </Grid>
            )}

            <Grid item xs={12}>
                <FormLabel required className="mandatoryfields">
                    Shift
                </FormLabel>
                <SelectBox
                    name="shiftID"
                    value={state.shiftID}
                    onChange={handleInput}
                    List={shiftList}
                    insertEmpty={false}
                    disabled={!!existingSchedule}
                    fullWidth
                />
                {errors.shiftID && <FormHelperText error>{errors.shiftID}</FormHelperText>}
            </Grid>

            <Grid item xs={12} sm={6}>
                <FormLabel required className="mandatoryfields">
                    Start Date
                </FormLabel>
                <DatePicker name="startDate" value={state.startDate} onChange={handleInput} fullWidth />
                {errors.startDate && <FormHelperText error>{errors.startDate}</FormHelperText>}
            </Grid>

            <Grid item xs={12} sm={6}>
                <FormLabel required className="mandatoryfields">
                    End Date
                </FormLabel>
                <DatePicker name="endDate" value={state.endDate} onChange={handleInput} fullWidth />
                {errors.endDate && <FormHelperText error>{errors.endDate}</FormHelperText>}
            </Grid>

            <Grid item xs={12}>
                <FormLabel required className="mandatoryfields">
                    Max Technicians Required
                </FormLabel>
                <TextBox
                    type="number"
                    name="maxTechniciansRequired"
                    value={state.maxTechniciansRequired}
                    onChange={handleInput}
                    inputProps={{ min: 0 }}
                    fullWidth
                />
                {errors.maxTechniciansRequired && <FormHelperText error>{errors.maxTechniciansRequired}</FormHelperText>}
            </Grid>

            <Grid item xs={12} container justify="flex-end" spacing={1} style={{ marginTop: '16px' }}>
                <Grid item xs={6} sm={3}>
                    <SecondaryButton fullWidth onClick={() => onClose(false)}>
                        Cancel
                    </SecondaryButton>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <SecondaryButton fullWidth color="primary" onClick={handleSubmit} isBtnLoader={isBtnLoader}>
                        {state.shiftScheduleID ? 'Update' : 'Create'}
                    </SecondaryButton>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default CreateCalendarModal;
